var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 12,
  viewBox: "0 0 19 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5 0.509337V11.4913L14.4917 7.49111V10.982C14.4917 11.2486 14.3944 11.4853 14.2005 11.6908C14.006 11.8976 13.7748 12 13.5083 12H1.52073C1.2289 12 0.985712 11.8976 0.791827 11.6908C0.597276 11.4853 0.5 11.2486 0.5 10.982V1.01867C0.5 0.752036 0.597276 0.515986 0.791827 0.309193C0.985712 0.103729 1.2289 0 1.52073 0H13.5083C13.7748 0 14.006 0.103729 14.2005 0.309193C14.3944 0.515986 14.4917 0.752036 14.4917 1.01867V4.50956L18.5 0.509337Z",
  fill: "#999999"
}))));
export default SvgIconVideo;